import React, { useEffect, useState } from 'react'
import { Form, Input, Button,  Row, Col, Select, Modal } from 'antd';
import { connect } from 'react-redux';
import {getActiveProducts,createBatch} from '../../actions/batch';
import { PlusSquareOutlined } from '@ant-design/icons';
import history from '../../history';
import AddProduct from '../products/addProduct';

const productList = new Map();

const { Option } = Select;
const AddBatch = ({getActiveProducts,createBatch,fnc,refresh}) => {
    const [products, setProducts] = useState([])
    const [isExpireable, setIsExpireable] = useState('')
    const [productId, setProductId] = useState(null)
    const [codeType, setCodeType] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false)

    const [form] = Form.useForm();
    
    useEffect( async () => {
        const res =  await getActiveProducts();
        for(let i = 0; i< res.length; i++) {
            productList.set(`${res[i].product_id}`, res[i])
        }

        setProducts(res)
    }, [])
    
    const createOptions = (label,value) => {
        return {label,value}
    }
    let option = [];
    option = (
    products ? products.map(item => 
        createOptions(item.name , item.product_id ))
    : null)

    const handleRefresh = async () =>{

        const res =  await getActiveProducts();
        for(let i = 0; i< res.length; i++) {
            productList.set(`${res[i].product_id}`, res[i])
        }

        setProducts(res)
    }
    const handleSearch = (e) => {
        const product_id = e.split('.')[1]
        setProductId(product_id)
        if(productList.has(product_id)){
            const product = productList.get(product_id);
            setIsExpireable(product?.life_time)
            form.setFieldsValue({
                name : product?.name,
                life_time : product?.life_time,
                price : product?.price,
                weight :  product?.weight,
                weight_unit : product?.weight_unit,
            })

        }
    }
    const onFinish = async (values) => {
        const res = await createBatch(values)
        if(res === 201){
            form.resetFields();
            refresh()
            fnc()
        }
      };
    
      const onFinishFailed = (errorInfo) => {
      };
    return ( 
        <>
        <Form
            name="basic"
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form}
            >
            <Row gutter={16}>
            {products.length > 0 ?
                <Col  xs={24}  md={24}>
                    
                    <Form.Item
                        label="Select Product"
                        name="product"
                        rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                        ]}
                    >
                        <Select showSearch style={{ width: '100%' }} onChange={(e)=> handleSearch(e)}>
                        {option.map(item=>(
                            <Option value={item.label + '.' + item.value}>{item.label}</Option>
                        ))}
                        </Select>
                    </Form.Item>
                </Col>
            : 
                <Col  xs={24}  md={24} style={{textAlign: 'center'}}>
                    <Button onClick={() => setIsModalVisible(true) } type='primary' size='large' icon={<PlusSquareOutlined />} style={{backgroundColor: 'red', color: '#FFF'}} >
                        You don't have any product. Please add a product first
                    </Button>
                </Col>
            }
            {productId ?
            <>
            
            <Col  xs={24}  md={12}>

                <Form.Item
                    label="Batch No"
                    name="batch_no"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input  />
                </Form.Item>
                
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Product price"
                    name="price"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>
                {/* <Form.Item
                    label="Product color"
                    name="color"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item> */}
                

                <Form.Item
                    label="Weight"
                    name="weight"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input type="number" />
                </Form.Item>
                    
                <Form.Item
                    label="Weight unit"
                    name="weight_unit"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} >
                    <Option value="Kg">kg</Option>
                    <Option value="g">gm</Option>
                    <Option value="ml">ml</Option>
                    <Option value="L">L</Option>
                    <Option value="lb">lb</Option>
                    <Option value="oz">oz</Option>
                    <Option value="kl">kl</Option>
                    <Option value="gsm">gsm</Option>
                    </Select>
                </Form.Item>
                
                <Form.Item
                    label="Status"
                    name="active"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} >
                    <Option value="active">Active</Option>
                    <Option value="inactive">Inactive</Option>
                    </Select>
                </Form.Item>
                
            </Col>
            <Col  xs={24}  md={12}>
                <Form.Item
                    label="Product duribility"
                    name="life_time"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} onChange={(e)=> setIsExpireable(e)}>
                    <Option value="expireable">Expireable</Option>
                    <Option value="nonexpireable">Non-expireable</Option>
                    </Select>
                </Form.Item>
                
                <Form.Item
                        label="Manufacture Date"
                        name="manufacture_date"
                        rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                        ]}
                    >
                        <Input type="date"/>
                    </Form.Item>

                {isExpireable === 'expireable' ? 
                    <Form.Item
                        label="Expiry Date"
                        name="expiry_date"
                        rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                        ]}
                    >
                        <Input type="date"/>
                    </Form.Item>
                : null}
                <Form.Item
                    label="Code Type"
                    name="code_type"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} onChange = {(e) => setCodeType(e)} >
                    <Option value="qrcode">QR Code</Option>
                    <Option value="barcode">Bar Code</Option>
                    </Select>
                </Form.Item>

                
                <Form.Item
                    label="Code count"
                    name="code_count"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    
                    <Input type="number" />
                </Form.Item>

                <Form.Item
                    label="File type"
                    name="file_type"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} >
                        {codeType === 'qrcode' ?
                        <>
                            <Option value="docx">DOCX</Option>
                            <Option value="xlsx">XLSX</Option>
                        </> :
                        <>
                            <Option value="xlsx">XLSX</Option>
                        </>
                        }
                    {/* <Option value="doc">Doc</Option> */}
                    </Select>
                </Form.Item>
          
            </Col>
            <Col xs={24}>
                <br />
                <Form.Item
                    // wrapperCol={{
                    // offset: 1,
                    // span: 22,
                    // }}
                    style={{textAlign: 'center'}}
                >
                    <Button type="primary" htmlType="submit">
                    Create
                    </Button>
                </Form.Item>
            </Col>
            </> : null}
           

            </Row>
        </Form>
        
<Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Add A New Product" visible={isModalVisible} onCancel={()=>setIsModalVisible(false)}>
<AddProduct close={() => setIsModalVisible(false)} fnc={handleRefresh} />
</Modal>
        </>
     );
}
 
export default connect(null,{getActiveProducts,createBatch})(AddBatch);